export const NUEVOASIENTO_OGCOMPRA = '1'
